<template>
  <div>
    <arrorImg bg="white"></arrorImg>
    <navBar title="活动详情" color="#ffffff" :pagetype="pageType"></navBar>
    <div class="activity-image">
      <modelone
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == 1"
      ></modelone>
      <modeltwo
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == 2"
      ></modeltwo>
      <modelthree
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == 3"
      ></modelthree>
      <modelfour
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == 4"
      ></modelfour>
      <modelfive
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == 5"
      ></modelfive>
      <modelsix
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == 6"
      ></modelsix>
      <modelseven
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == 8"
      ></modelseven>
      <modeleight
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == 7"
      ></modeleight>
      <modelnine
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == 9"
      ></modelnine>
          <modelteen
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -1"
      ></modelteen>
       <modeleleven
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -2"
      ></modeleleven>
      <modeltwelve
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -3"
      ></modeltwelve>
      <modelthirteen
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -4"
      ></modelthirteen>
      <modelfourteen
        @payActivity="payActivity"
        :activityId="activityId"
        :status="status"
        :termOfValidity="ruleForm.termOfValidity"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        :switches="ruleForm.switches"
        v-if="activityMaterialId == -5"
      ></modelfourteen>
      <modelfifteen
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -6"
      ></modelfifteen>
      <modelsixteen
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -7"
      ></modelsixteen>
      <modelseventeen
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -8"
      ></modelseventeen>
      <modeleightteen
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -9"
      ></modeleightteen>
      <modelnineteen
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        :H="H"
        :M="M"
        :S="S"
        v-if="activityMaterialId == -10"
      ></modelnineteen>
      <modeltwenty
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -11"
        :H="H"
        :M="M"
        :S="S"
      ></modeltwenty>
      <modeltwentyone
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        :H="H"
        :M="M"
        :S="S"
        v-if="activityMaterialId == -12"
      ></modeltwentyone>
      <modeltwentytwo
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -13"
        :H="H"
        :M="M"
        :S="S"
      ></modeltwentytwo>
      <modeltwentythree
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        :H="H"
        :M="M"
        :S="S"
        v-if="activityMaterialId == -14"
      ></modeltwentythree>
      <modeltwentyfour
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -15"
        :H="H"
        :M="M"
        :S="S"
      ></modeltwentyfour>
      <modeltwentyfive
      @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -16"
        :H="H"
        :M="M"
        :S="S"
      ></modeltwentyfive>
      <modeltwentysix
      @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -17"
        :H="H"
        :M="M"
        :S="S"
      ></modeltwentysix>
      <modeltwentyseven
      @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -18"
        :H="H"
        :M="M"
        :S="S"
      ></modeltwentyseven>
      <modeltwentyeight
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -19"
        :H="H"
        :M="M"
        :S="S"
      ></modeltwentyeight>
      <modeltwentynine
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -20"
        :H="H"
        :M="M"
        :S="S"
      ></modeltwentynine>
      <modelthirty
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -21"
        :H="H"
        :M="M"
        :S="S"
      ></modelthirty>
      <modelthirtyone
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -24"
        :H="H"
        :M="M"
        :S="S"
      ></modelthirtyone>
      <modelthirtytwo
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -23"
        :H="H"
        :M="M"
        :S="S"
      ></modelthirtytwo>
      <modelthirtythree
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -22"
        :H="H"
        :M="M"
        :S="S"
      ></modelthirtythree>
      <modelthirtyfour
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -25"
        :H="H"
        :M="M"
        :S="S"
      ></modelthirtyfour>
      <modelthirtyfive
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -26"
        :H="H"
        :M="M"
        :S="S"
      ></modelthirtyfive>
      <modelthirtysix
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -27"
        :H="H"
        :M="M"
        :S="S"
      ></modelthirtysix>
      <modelthirtyseven
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -28"
        :H="H"
        :M="M"
        :S="S"
      ></modelthirtyseven>
      <modelthirtyeight
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -29"
        :H="H"
        :M="M"
        :S="S"
      ></modelthirtyeight>
      <modelthirtynine
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -30"
        :H="H"
        :M="M"
        :S="S"
      ></modelthirtynine>
      <modelfourty
        @payActivity="payActivity"
        :status="status"
        :purchaseLimitDTO="ruleForm.purchaseLimitDTO"
        :endTime="ruleForm.endTime"
        :materialParamsDTO="ruleForm.materialParamsDTO"
        v-if="activityMaterialId == -31"
        :H="H"
        :M="M"
        :S="S"
      ></modelfourty>
    </div>
  </div>
</template>
<script>
import modelone from "./compontent/modelone.vue";
import modeltwo from "./compontent/modeltwo.vue";
import modelthree from "./compontent/modelthree.vue";
import modelfour from "./compontent/modelfour.vue";
import modelfive from "./compontent/modelfive.vue";
import modelsix from "./compontent/modelsix.vue";
import modelseven from "./compontent/modelseven.vue";
import modeleight from "./compontent/modeleight.vue";
import modelnine from "./compontent/modelnine.vue";
import modelteen from "./compontent/modelteen.vue";
import modeleleven from "./compontent/modeleleven.vue";
import modeltwelve from "./compontent/modeltwelve.vue";
import modelthirteen from "./compontent/modelthirteen.vue";
import modelfourteen from "./compontent/modelfourteen.vue";
import modelfifteen from "./compontent/modelfifteen.vue";
import modelsixteen from "./compontent/modelsixteen.vue";
import modelseventeen from "./compontent/modelseventeen.vue";
import modeleightteen from "./compontent/modeleightteen.vue";
import modelnineteen from "./compontent/modelnineteen.vue";
import modeltwenty from "./compontent/modeltwenty.vue";
import modeltwentyone from "./compontent/modeltwentyone.vue";
import modeltwentytwo from "./compontent/modeltwentytwo.vue";
import modeltwentythree from "./compontent/modeltwentythree.vue";
import modeltwentyfour from "./compontent/modeltwentyfour.vue";
import modeltwentyfive from "./compontent/modeltwentyfive.vue";
import modeltwentysix from "./compontent/modeltwentysix.vue";
import modeltwentyseven from "./compontent/modeltwentyseven.vue";
import modeltwentyeight from "./compontent/modeltwentyeight.vue";
import modeltwentynine from "./compontent/modeltwentynine.vue";
import modelthirty from "./compontent/modelthirty.vue";
import modelthirtyone from "./compontent/modelthirtyone.vue";
import modelthirtytwo from "./compontent/modelthirtytwo.vue";
import modelthirtythree from "./compontent/modelthirtythree.vue";
import modelthirtyfour from "./compontent/modelthirtyfour.vue";
import modelthirtyfive from "./compontent/modelthirtyfive.vue";
import modelthirtysix from "./compontent/modelthirtysix.vue";
import modelthirtyseven from "./compontent/modelthirtyseven.vue"
import modelthirtyeight from "./compontent/modelthirtyeight.vue"
import modelthirtynine from "./compontent/modelthirtynine.vue"
import modelfourty from "./compontent/modelfourty.vue"
import { Toast, MessageBox } from "mint-ui";
import arrorImg from "../../components/arrow-img.vue";
import navBar from "../components/navbar.vue";
export default {
  name: "bookModelActivity",
  components: {
    arrorImg,
    navBar,
    modelone,
    modeltwo,
    modelthree,
    modelfour,
    modelfive,
    modelsix,
    modelseven,
    modeleight,
    modelnine,
    modelteen,
    modeleleven,
    modeltwelve,
    modelthirteen,
    modelfourteen,
    modelfifteen,
    modelsixteen,
    modelseventeen,
    modeleightteen,
    modelnineteen,
    modeltwenty,
    modeltwentyone,
    modeltwentytwo,
    modeltwentythree,
    modeltwentyfour,
    modeltwentyfive,
    modeltwentysix,
    modeltwentyseven,
    modeltwentyeight,
    modeltwentynine,
    modelthirty,
    modelthirtyone,
    modelthirtytwo,
    modelthirtythree,
    modelthirtyfour,
    modelthirtyfive,
    modelthirtysix,
    modelthirtyseven,
    modelthirtyeight,
    modelthirtynine,
    modelfourty
  },
  data() {
    return {
      status: 1, //活动状态
      activityMaterialId: 0, //活动模板id
      activityId: 0,
      payItem: {
        settingsId: 0,
        money: 0, // 单位:分
        bookId: 0,
        chapterId: 0,
        vipId: 0,
        activityId: 0, //活动编号 ，会员和充值默认为0
        activityTemplateUniqueId: 0,
        sourceVersion: 1,
        cardType:''
      },
      out_trade_no: "",
      pageType: "",
      isEntranceData: "",
      isBookRead: "",
      ruleForm: {
        termOfValidity:'',//有效期
        switches:1,//值活动书币领取提醒开关,1开启，2关闭（新增字段）
        startTime: "", //开始时间
        endTime: "", //结束时间
        materialParamsDTO: {
          //模板动态参数对象
          type: 1, // 类型，1书币，2会员，3组合
          materialParamsDetailDTOList: [
            //这里采用数组，因为组合模板有多个对象
            {
              giveAwayMoney: "", //赠送金额,单位分
              materialParamsDetailType: 1, //组合类型时，组合内每个对象的类型，1书币，2会员
              rechargeMoney: "", //充值金额,单位分
              totalbookCoin: "", //总共获得书币数
              giveAwayMember: "", //会员天数类型，1：1个月；2：1个季度；3：半年；4：一年
            },
          ],
        },
        purchaseLimitDTO: {
          //充值活动限购
          purchaseLimitType: 0, //充值活动限购类型,0普通限购，1每日限购，2不限购
          purchaseLimitValue: 1, //充值活动限购值，如果是不限购，那么值为0
        },
      },
      timer:null,
      H:'',
      M:'',
      S:''
      
    };
  },
  beforeRouteEnter(to, from, next) {
    console.log(from);
    console.log(to);
    if (!from.name && to.name == "bookModelActivity") {
      // 当从上个页面chooseCoupons返回当前页面时，不刷新当前页面
      to.meta.isBack = true;
      to.meta.keepAlive = true;
    } else {
      to.meta.isBack = false;
      to.meta.keepAlive = true;
    }
    next();
  },
  mounted() {
    var that = this;
    window.addEventListener("pageshow", function (e) {
      console.log(e)
      //如果检测到页面是从“往返缓存”中读取的，刷新页面
      if (e.persisted) {
        that.getOrderStatus();
        setTimeout(()=>{
          that.findRechargeActivityById();
        },500)
      }
    });
  },
  activated() {
     this.activityId = this.$route.query.activityId;
    this.payItem.activityId = this.$route.query.activityId;
    this.pageType = this.$route.query.pageType;
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    }
    if (this.$route.query.isBookRead) {
      this.isBookRead = this.$route.query.isBookRead;
    }
    if (this.$route.query.bookId) {
      this.payItem.bookId = this.$route.query.bookId;
      this.payItem.chapterId = this.$route.query.chapterId;
    }
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
    var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录手动登录
    } else if (
      isWxAuthorized == 0 &&
      city == 1 &&
      openid &&
      !this.$store.state.user.isSNS
    ) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      this.findRechargeActivityById();
    } else {
      this.findRechargeActivityById();
    }
    this.$commonApi.share();
  },
  methods: {
    countDownTime(time) {//活动时间倒计时
				var nowtime = new Date(), //获取当前时间
					endtime = time; //定义结束时间
				let timestamp = endtime - nowtime.getTime(); //距离结束时间的毫秒数
				if (timestamp < 0) {
          clearInterval(this.timer)
          return;
				}
				let D = Math.floor(timestamp / (1000 * 60 * 60 * 24)); //计算天数
				let H =(D*24)+ Math.floor(timestamp / (1000 * 60 * 60) % 24); //计算小时数
				let m = Math.floor(timestamp / (1000 * 60) % 60); //计算分钟数
				let s = Math.floor(timestamp / 1000 % 60); //计算秒数
  
				if (m < 10) {
					m = '0' + m
				}
				if (s < 10) {
					s = '0' + s
				}
        this.H=H;
        this.M=m;
        this.S=s;
			},
realTime() {
  var that=this;
				var endTiem = new Date(that.ruleForm.endTime.replace(/-/g,'/')).getTime()
				this.countDownTime(endTiem);
        
			},
    getOrderStatus() {
      var isActivity = this.$base.getStorage("isActivity");
      if (isActivity == 1 && this.$base.getStorage("orderNum")) {
        //订单支付成功
        console.log("订单支付成功");
        var params = {
          orderNo: this.$base.getStorage("orderNum"),
          currentPageType: 2,
        };
        this.$api.getOrderStatus(params).then((res) => {
          this.$base.removeStorage("isActivity");
          this.$base.removeStorage("orderNum");
          if (res.status == 1) {
            Toast({
              message: res.message,
            });
          }
        });
      }
    },
    payActivity(item) {
      if(item.data==1){//领取书币
        var params={
          activityId:this.activityId,
          cardType:item.item.cardType,
          queryType: 1,
        }
        this.$api.monthCards(params).then(res=>{
          if(res.status==1){
            Toast({
                message: '领取成功',
              });
            this.findRechargeActivityById();
          }
        })
      }else{
        if (this.status != 2) {
        return false;
      }
      if (item) {
        this.payItem.money = item.rechargeMoney;
        this.payItem.activityTemplateUniqueId = item.activityTemplateUniqueId;
        this.payItem.cardType=item.cardType;
      }
      this.goPay();
      }
    },
    insertPageAccessData(activeName) {
      var prevPage = "";
      if (this.pageType === "bookTask") {
        prevPage = "任务中心";
      } else if (this.pageType === "bookMine") {
        prevPage = "我的";
      } else if (this.pageType === "bookRead") {
        prevPage = "阅读器";
      } else if (this.pageType === "bookCity") {
        prevPage = "书城";
      }else if (this.pageType === "bookRecharge") {
        prevPage = "充值中心";
      }
      var params = {
        pageName: "活动详情",
        pageRemark: "活动名称：" + activeName + "；上级页面：" + prevPage,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    findRechargeActivityById() {
      var params = {
        activityId: this.activityId,
        sourceVersion: 1,
      };
      this.$api.findRechargeActivityById(params).then((res) => {
        if (res.status == 1) {
          this.status = res.data.status;
          this.activityMaterialId = res.data.activityMaterialId;
          if(res.data.activityType==7){
            res.data.materialParamsDTO.materialParamsDetailDTOList.forEach((item,index)=>{
            if(index==0){
              item.color='#174169';
            }else if(index==1){
              item.color='#434343';
            }else if(index==2){
              item.color='#434343';
            }else if(index==3){
              item.color='#4C065D';
            }
          })
          }
          this.ruleForm = res.data;
          if(res.data.status==2){
            this.timer=setInterval(this.realTime, 1000);
          }
          this.insertPageAccessData(res.data.activeName);
          this.getOrderStatus();
        }
      });
    },
    goPay() {
      this.$api.separateWxpay(this.payItem).then((res) => {
        if (res.status == 1) {
          // h5公众号微信支付
          var data = res.data;
          // #ifdef H5
          var pageType = "";
          if (this.pageType == "bookRead") {
            pageType = "bookRead";
          } else {
            pageType = "bookActivity";
          }
          // if (this.isBookRead == "bookRead" || pageType == "bookRead") {
          this.$base.setStorage("isActivity", 1);
          this.$base.setStorage("orderNum", data.orderNo);
          // }
          var url_config = "https://" + window.location.host + "/";
          var WXurl = this.$commonApi.PayURL(); //环境
          var URL =
            WXurl +
            "/payIndex.html?pageType=" +
            this.pageType +
            "&type=bookActivity&orderNo=" +
            data.orderNo +
            "&officialCode=" +
            data.officialCode +
            "&openid=" +
            this.$base.getStorage("openid") +
            "&configUrl=" +
            url_config +
            "&isBookRead=" +
            this.isBookRead;
          window.location.href = URL;
        } else if (res.status == 0) {
          Toast({
            message: res.message,
          });
        }
      });
    },
    getUserCurrency() {
      this.$api.getUserCurrency().then((res) => {
        if (res.status == 1) {
          this.$base.setStorage("currency", res.data);
        }
      });
    },
  },
};
</script>

<style scoped>
.activity-image {
  width: 100%;
  padding-top: calc(44px + env(safe-area-inset-top));
}

.activity-img {
  width: 100%;
}

.btn-activity {
  width: 100%;
  height: 44px;
  text-align: center;
  background-color: #de3b34;
  position: fixed;
  bottom: 0px;
  left: 0;
}

.btn-text {
  line-height: 44px;
  color: #ffffff;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/view/bookModelActivity/index.vue